module.exports = __webpack_public_path__ + "img/ufpb.ff1fd4c7.png";